export default "__VITE_ASSET__bS021APE__"